import React from 'react';

export const InfoIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 24, width = 24, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    className={className}
    viewBox="0 0 33 33"
  >
    <g fill="black">
      <path d="M16.5 3.09375C23.925 3.09375 29.9062 9.075 29.9062 16.5C29.9062 23.925 23.925 29.9062 16.5 29.9062C9.075 29.9062 3.09375 23.925 3.09375 16.5C3.09375 9.075 9.075 3.09375 16.5 3.09375ZM16.5 2.0625C8.55938 2.0625 2.0625 8.55938 2.0625 16.5C2.0625 24.4406 8.55938 30.9375 16.5 30.9375C24.4406 30.9375 30.9375 24.4406 30.9375 16.5C30.9375 8.55938 24.4406 2.0625 16.5 2.0625Z" />
      <path d="M16.5 23.7188C17.0695 23.7188 17.5312 23.257 17.5312 22.6875C17.5312 22.118 17.0695 21.6562 16.5 21.6562C15.9305 21.6562 15.4688 22.118 15.4688 22.6875C15.4688 23.257 15.9305 23.7188 16.5 23.7188Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 9.28125C16.7848 9.28125 17.0156 9.5121 17.0156 9.79688V19.0781C17.0156 19.3629 16.7848 19.5938 16.5 19.5938C16.2152 19.5938 15.9844 19.3629 15.9844 19.0781V9.79688C15.9844 9.5121 16.2152 9.28125 16.5 9.28125Z"
      />
    </g>
  </svg>
);
